<template>
  <div>
    <b-row>
      <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
      <b-col v-if="!isLoading">
        <ResearchManagerForm
          :title="$lang.researchLang.relationResearchManager"
          :parentPermissions="parentPermissions"
          @submit="save"
          @closeModal="closeModal"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ResearchManagerForm from "./../forms/researchManagerForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";

export default {
  components: {
    ResearchManagerForm,
    LoadingSpinner,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  inject: ["researchManagerRepository"],
  methods: {
    async save(payload) {
      this.isLoading = true;
      try {
        const response = await this.researchManagerRepository.create(payload);
        this.$notify.success(response.data.message);
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.$emit("modal-end-up");
    },
  },
};
</script>
